import React from 'react';

import {Link} from 'react-router-dom';

import NotificationsList from './components/NotificationsList';
import Icon from '../Icon';
import Title from "../Title";
import createLink from "../../../libs/createLink";

const Notifications = (props) => (
    <div id="notifications" className="notifications">
        <div className="container">
            <div className="card big">
                <div className="topline-notifications">
                    <Title heading={"heading-2"} display={"display-2"}>Vos notifications</Title>
                    <div className="settings-notifications">
                        <Link to={createLink("userMeSettingsOptionsNotifications")}>
                            <Icon type="cog"/> Paramètres de notification
                        </Link>
                    </div>
                </div>
                <NotificationsList isPage={true}/>
            </div>
        </div>
    </div>
);

export default Notifications;
